<template>
  <div class="DragAndCropSource">
    <div class="vueDrag">
      <VueDragResize
        v-if="isShowDrag"
        :parentLimitation="true"
        :w="draggableResize.width"
        :h="draggableResize.height"
        :x="draggableResize.x"
        :y="draggableResize.y"
        :isDraggable="false"
        :sticks="handles()"
        @clicked="onActivated"
        :active="dragActive"
        :aspectRatio="true"
        @resizing="onResize"
      >
        <div
          class="borderSet"
          @click="selectedDraggableSource"
        ></div>
        <img
          :src="imgInfoUrl"
          :onerror="errorImg"
          :id="lBandInfo.id"
        />
      </VueDragResize>
    </div>
  </div>
</template>
<script>
import Bus from '@/assets/js/vueBus.js'
import VueDragResize from 'vue-drag-resize'

export default {
  name: 'DragLBand',
  components: {
    VueDragResize
  },
  data () {
    return {
      // 拖拽的初始值
      draggableResize: {
        width: 0,
        x: 0,
        y: 0,
        height: 0
      },
      isShowDrag: false,
      // 默认图片
      imgInfoUrl: require('./Source-placeholder.jpg'),
      errorImg: 'this.src="' + require('./Source-placeholder.jpg') + '"',
      id: '',
      isFirst: true, // 表示刚刷新，或者新创建得source
      zorder: 1,
      dragActive: false
    }
  },
  props: {
    // 每一个LBand的样式
    lBandInfo: {
      type: Object,
      default: () => ({})
    },
    // 父盒子的宽高
    parentStyle: {
      type: Object,
      default: null
    }
  },
  created () {
    Bus.$on('updateLBandCanvas', this.resizeSource)
  },
  mounted () {
    // 将每一个组件抛出去
    const cropList = {
      id: this.lBandInfo.id,
      components: this
    }
    this.$emit('cropComp', cropList)
    this.InitSourceSize(this.lBandInfo, this.parentStyle)
  },
  computed: {
  },
  methods: {
    // 方向
    handles () {
      if (this.squeezeType === 2) {
        return ['br']
      } else if (this.squeezeType === 3) {
        return ['tr']
      } else if (this.squeezeType === 0) {
        return ['bl']
      } else {
        return ['tl']
      }
    },
    // 拖拽事件
    async onResize ({ left, top, width, height }) {
      this.modifyDragResizeData(width, height, left, top)
      const position = {
        x: left,
        y: top,
        id: this.id,
        width: width,
        height: height,
        type: 'change'
      }
      Bus.$emit('draggable-Source', position)
    },
    // 改变pip的位置及大小
    modifyDragResizeData (width, height, x, y, squeezeType) {
      // debugger
      if (width) this.draggableResize.width = width
      if (height) this.draggableResize.height = height
      if (x || x == 0) this.draggableResize.x = x
      if (y || y == 0) this.draggableResize.y = y
      if (squeezeType != undefined) this.squeezeType = squeezeType
    },
    // 根据用户输如的值重置相关值
    async resizeSource (data) {
      if (data.type == 'background') return
      if (data.id !== this.id) return
      const { width, height, x, y, squeezeType } = data
      if (width + x > 1920 || height + y > 1080) {
        this.$message.error('The source must all be in the canvas')
        return
      }
      this.isShowDrag = false
      this.$nextTick(async () => {
        await this.modifyDragResizeData(width, height, x, y, squeezeType)
        this.isShowDrag = true
      })
    },
    // 各项数据的初始化，分为已原始数据和重新创建的
    InitSourceSize (imgInfo) {
      this.isShowDrag = false
      // 由于拖拽插件的关系，每次都需先销毁再创建
      this.$nextTick(async () => {
        const { width, height, x, y, id, squeezeType } = imgInfo
        // 将source的初始大小保存起来
        // draggeableResize一直是页面上元素显示时的宽高坐标
        await this.modifyDragResizeData(width, height, x, y, squeezeType)
        this.zorder = imgInfo.zorder
        this.id = id
        this.isShowDrag = true
        this.isFirst = false
      })
    },
    // 告诉CropVideo组件当前选择的source Id
    selectedDraggableSource (event) {
      event.stopPropagation()
      Bus.$emit('draggable-Source', {
        type: 'focus'
      })
    },
    onActivated () {
      this.dragActive = true
    }
  },
  beforeDestroy () {
    this.$emit('cropComp', this.id)
    Bus.$off('updateLBandCanvas', this.resizeSource)
  }
}
</script>
<style lang="less">
.DragAndCropSource {
  width: 100%;
  height: 100%;

  .borderSet {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(1, 1, 1, 0.1);
  }

  .vueDrag {
    width: 100%;
    height: 100%;
    img {
      width: 100%;
      height: 100%;
    }
  }
}
</style>
